import React from "react";
import { Box, Typography, Container, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { HeroSection } from "../StyledComponents";
import DashboardToolsShortcuts from "./DashboardToolsShortcuts";
import DashboardTeacherShortcuts from "./DashboardTeacherShortcuts";

const LessonGeneration = ({ onBack, role, theme, user, styles }) => {
  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.innerContainer,
          width: { xs: "100%", md: "100%" },
          margin: "0 auto",
          mt: 4,
        }}
      >
        <HeroSection elevation={0} sx={{ display: "none" }}>
          <Container maxWidth="lg">
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 500,
                textAlign: "center",
                fontSize: "2rem",
              }}
            >
              Generera egna lektioner
            </Typography>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 400,
                textAlign: "center",
                opacity: 0.9,
                maxWidth: "800px",
                mx: "auto",
                display: "none",
              }}
            >
              Glöm inte att spara det du genererar i din egen lektionsbank :)
            </Typography>
          </Container>
        </HeroSection>

        <Box sx={{ mb: 2 }}>
          <DashboardToolsShortcuts
            role={role}
            resetCategory=""
            theme={theme}
            user={user}
            styles={styles}
            onlyFetchFavorites={true}
          />
        </Box>

        <DashboardTeacherShortcuts theme={theme} user={user} />
      </Box>
    </Box>
  );
};

export default LessonGeneration;
